import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';

function Message({ action, variables, setOpenVariable }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.DISPLAY-MESSAGE.';

    useEffect(() => {
        if (!action.fields.title) {
            action.fields.title = { value: '', isRequired: true }
        }
        if (!action.fields.message) {
            action.fields.message = { value: '', isRequired: true }
        }
    }, [action.fields]);
    return (
        <div>
            <div className="form-element">
                {t(label + 'TITLE-NAME')}
                <TextInput action={action} inputName="title" variables={variables} setOpenVariable={setOpenVariable}  isRequired={true} fieldType='string' displayName={t(label + 'TITLE-NAME')} />
            </div>
            <div className="form-element">
                {t(label + 'MESSAGE-NAME')}
                <TextInput action={action} inputName="message" variables={variables} setOpenVariable={setOpenVariable} isRequired={true} multiline={true}  fieldType='string' displayName={t(label + 'MESSAGE-NAME')}/>
            </div>
        </div>
    )
}

export default Message;